import {
  Activity,
  Briefcase,
  Calendar,
  FileText,
  Inbox,
  PieChart,
  Settings,
  ShieldCheck,
  UserCog,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
}

export const navItems: NavItem[] = [
  { to: '/calendar', label: 'Calendário', icon: Calendar },
  { to: '/shifts', label: 'Plantões Ativos', icon: Activity },
  { to: '/fiscal', label: 'Fiscal', icon: FileText },
  { to: '/inbox', label: 'Inbox', icon: Inbox },
  { to: '/summary', label: 'Resumo', icon: PieChart },
  { to: '/services', label: 'Serviços', icon: Briefcase },
  { to: '/accountant', label: 'Contador', icon: UserCog },
  { to: '/certificates', label: 'Certificado Digital', icon: ShieldCheck },
  { to: '/settings', label: 'Configurações', icon: Settings },
];
